import { render, staticRenderFns } from "./MembershipAccessTable.vue?vue&type=template&id=fcec161a&"
import script from "./MembershipAccessTable.vue?vue&type=script&lang=js&"
export * from "./MembershipAccessTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports